module.exports = __webpack_public_path__ + "img/login_bg.cb178405.jpg";